import { loadPaystackInline, resumeInlineTransaction } from "./paystackInline";
import {
  closePopup,
  openPaystackPopup,
  sendPopupTo,
  waitForPopupClose,
} from "./paystackPopup";

export const launchPaystack = async (
  initiation,
  { mode = "window", popup, allowRedirect = false } = {}
) => {
  if (mode === "redirect") {
    closePopup(popup);
    window.location.assign(initiation.authorizationUrl);

    return "redirected";
  }

  if (popup && !popup.closed && sendPopupTo(popup, initiation.authorizationUrl)) {
    await waitForPopupClose(popup);

    return "closed";
  }

  closePopup(popup);

  if (initiation.accessCode) {
    try {
      const PaystackPop = await loadPaystackInline();
      const outcome = await resumeInlineTransaction(PaystackPop, initiation.accessCode);

      if (outcome !== "stalled") return outcome;
    } catch {
      /* inline unavailable — fall through to a fresh popup */
    }
  }

  return launchPaystackPopup(initiation, { allowRedirect });
};

export const launchPaystackPopup = async (initiation, { allowRedirect = false } = {}) => {
  const popup = openPaystackPopup(initiation.authorizationUrl);

  if (!popup) {
    if (!allowRedirect) return "popup-blocked";

    window.location.assign(initiation.authorizationUrl);

    return "redirected";
  }

  await waitForPopupClose(popup);

  return "closed";
};
